import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import Select from 'react-select'
import HolidayForm from '../../forms/Holidays';
import { request, reportErrorToHoneybadger } from '../../helpers/Requests'
import SlidingPane from "../../components/shared/ScrollableSlidingPane";
import Page from '../../components/shared/Page';
import TypeOfPersonSelect from '../../components/shared/TypeOfPersonSelect';
import HelpText from '../../components/help/HelpText';
import { arrayParamBuilder, STAFF_TYPE_OF_PEOPLE, optionalParam, buildParams, getContrastYIQ, holidaysDaysUsed } from '../../utilities/Generic'
import { collectHexCodes } from '../../utilities/Colors'

import { format, startOfMonth, endOfMonth, startOfWeek, endOfWeek, eachDayOfInterval, isSameMonth, isWithinInterval, startOfDay, endOfDay, isSameDay } from 'date-fns';

class StaffHolidaysShow extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleMultiSelectChange = this.handleMultiSelectChange.bind(this);
    this.shiftYear = this.shiftYear.bind(this);
    this.handleMultiCheckbox = this.handleMultiCheckbox.bind(this);
    this.handleUpdatePanel = this.handleUpdatePanel.bind(this);
    this.handleNewPanel = this.handleNewPanel.bind(this);
    this.closePanel = this.closePanel.bind(this);
  }

  static DAYS_OF_WEEK = ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"];
  static MONTHS_IN_YEAR = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];

  state = {
    year: null,
    locations: [],
    roles: [],
    tags: [],
    people: [],
    person_ids: [],

    location_id: this.props.match.params.id,
    role_id: "",
    type_of_person: "",
    tag_ids: [],
    holidayId: null,
    selectedPersonId: null,
    selectedPersonName: null,
    updatePanelToggle: false,
    newPanelToggle: false,

    locationsLoaded: false,
    rolesLoaded: false,
    tagsLoaded: false,
    holidaysLoaded: false,

    error: null,
    unauthorized: null,

    refresh_year: new Date().getFullYear(),
    refresh_tag_ids: [],
    refresh_role_id: "",
    refresh_person_ids: [],
    refresh_type_of_person: ""
  };

  handleNewPanel(event) {
    this.setState({newPanelToggle: true});
  }

  handleUpdatePanel(event) {
    this.setState({
      holidayId: event.currentTarget.dataset.holidayId,
      selectedPersonId: event.currentTarget.dataset.personId,
      selectedPersonName: event.currentTarget.dataset.personName,
      updatePanelToggle: true
    });
  }

  closePanel() {
    this.setState({
      holidayId: null,
      selectedPersonId: null,
      selectedPersonName: null,
      newPanelToggle: false,
      updatePanelToggle: false
    });

    this.fetchData();
  }

  handleChange(event) {
    const name = event.target.name;
    const value = event.target.value;

    const url = {
      year: this.state.year,
      tag_ids: this.state.tag_ids,
      role_id: this.state.role_id,
      person_ids: this.state.person_ids,
      type_of_person: this.state.type_of_person,
      location_id: this.state.location_id
    }

    url[name] = value

    if (name !== "person_ids") {
      url.person_ids = []
    }

    const params = buildParams(
      optionalParam("year", `${url.year}`),
      optionalParam("tag_ids", url.tag_ids),
      optionalParam("role_id", url.role_id),
      optionalParam("person_ids", url.person_ids),
      optionalParam("type_of_person", url.type_of_person),
    )
    this.props.history.push(`/staff-holidays/${url.location_id}?${params}`);
  }

  handleMultiCheckbox(event) {
    const name = parseInt(event.target.name);
    const value = event.target.checked;

    const person_ids = [...this.state.person_ids];

    if (value === true) {
      if (!person_ids.includes(name)) {
        person_ids.push(name)
      }
    }
    else if (value === false) {
      if (person_ids.includes(name)) {
        const index = person_ids.indexOf(name)
        person_ids.splice(index, 1)
      }
    }

    const fakeEvent = {}
    fakeEvent.target = {}
    fakeEvent.target.name = "person_ids"
    fakeEvent.target.value = person_ids

    this.handleChange(fakeEvent)
  }

  handleMultiSelectChange(data, meta) {
    const fakeEvent = {}
    fakeEvent.target = {}
    fakeEvent.target.name = meta.name
    fakeEvent.target.value = data.map(option => option.value);

    this.handleChange(fakeEvent)
  }

  shiftYear(direction) {
    const fakeEvent = {}
    fakeEvent.target = {}
    fakeEvent.target.name = "year"
    fakeEvent.target.value = this.state.year + direction;

    this.handleChange(fakeEvent)
  }

  getHolidaysForDay(day) {
    const holidays = [];
    const filteredPeople = this.state.person_ids.length === 0 ? this.state.people : this.state.people.filter(person => this.state.person_ids.includes(person.id))

    filteredPeople.forEach(person => {
      person.holidays.forEach(holiday => {
        const start = startOfDay(new Date(holiday.start_date));
        const end = endOfDay(new Date(holiday.end_date));

        if (isWithinInterval(day, {start,end})) {
          const startHalfDay = holiday.half_day_work_at_start && isSameDay(start, day)
          const endHalfDay = holiday.half_day_work_at_end && isSameDay(end, day)

          holidays.push({ id: holiday.id, person_id: person.id, person_name: person.name, half_day_work_at_start: startHalfDay, half_day_work_at_end: endHalfDay });
        }
      });
    });
  
    return holidays;
  }

  renderMonth(monthIndex, personColours) {
    const year = this.state.year;

    const monthDate = new Date(year, monthIndex);
    const monthStart = startOfMonth(monthDate);
    const monthEnd = endOfMonth(monthDate);

    const calendarStart = startOfWeek(monthStart, { weekStartsOn: 1 });
    const calendarEnd = endOfWeek(monthEnd, { weekStartsOn: 1 });

    const days = eachDayOfInterval({ start: calendarStart, end: calendarEnd });

    return (
      <div key={monthIndex} className="year-calendar-month">
        <div className="month-title">
          {format(monthDate, 'MMMM')}
        </div>

        <div className="weekday-row">
          {StaffHolidaysShow.DAYS_OF_WEEK.map(day => (
            <div key={day} className="weekday">
              {day}
            </div>
          ))}
        </div>

        <div className="days-grid">
          {days.map(day => {
            const holidays = this.getHolidaysForDay(day);

            // Just to dim the days that appear at the start and end of the month but are actually part of the previous or next month.
            const outsideMonth = !isSameMonth(day, monthDate) ? "outside-month " : "";

            return (
              <div key={day.toISOString()} className={`day-cell ${outsideMonth}`}>
                {outsideMonth === "" && (
                  <div className="holiday-layers">
                    {holidays.map(holiday => (
                      <div
                        key={`${holiday.id}`}
                        className="holiday-layer"
                        id={holiday.id}
                        data-holiday-id={holiday.id}
                        data-person-id={holiday.person_id}
                        data-person-name={holiday.person_name}
                        style={{
                          backgroundColor: personColours[holiday.person_id],
                          height: `${100.00 / holidays.length}%`,
                          width: holiday.half_day_work_at_start || holiday.half_day_work_at_end ? "50%" : "100%",
                          marginLeft: holiday.half_day_work_at_start ? "auto" : "0"
                        }}
                        onClick={this.handleUpdatePanel}
                      />
                    ))}
                  </div>)}
                <div className="day-number">
                  {format(day, "d")}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  renderPeople(personColours) {
    const { people, person_ids } = this.state;

    if (people.length === 0) {
      return
    }

    return (
      <div className="selection-block small-bottom-margin">
        <HelpText className="inline right" page={'staff_holidays'} section={'usage'} />

        Filter by person:
        {people.map(person => {
          const holidaysCount = holidaysDaysUsed(person.holidays)
          let allowedHolidays
          if (person.allowed_holidays === null ) {
            allowedHolidays =  "?"
          }
          else {
            allowedHolidays = parseFloat(person.allowed_holidays)
          }

          // In JS, comparison of a number with "?" always returns false
          const red = holidaysCount > allowedHolidays ? "red-text" : ""
          
          return (
          <div className="selection-block right-label" key={`person_${person.id}`}>
            <input className="clickable" type="checkbox" id={person.id} name={person.id} checked={person_ids.includes(person.id)} onChange={this.handleMultiCheckbox} />
            <label className="clickable" htmlFor={person.id} style={{ backgroundColor: personColours[person.id], color: getContrastYIQ(personColours[person.id]) }}>
              {person.name}
            </label>
            (<span className={red}>{holidaysCount}</span>/{allowedHolidays})
          </div>
        )})}
      </div>
    )
  }

  renderFilters(personColours) {
    const { location_id, type_of_person, role_id, tag_ids, locations, roles, tags } = this.state;

    const selectOptions = tags.map(tag => ({ value: tag.id, label: tag.name }))
    const selectedTags = selectOptions.filter(option => tag_ids.includes(option.value))

    return (
      <div className="export-selection">
        <div className="week-buttons">
          <div className="button" onClick={() => this.shiftYear(-1)}>Previous Year</div>
          <div className="button" onClick={() => this.shiftYear(1)}>Next Year</div>
        </div>
        <div className="selection-block">
          <label className="column">Location:</label>
          <select name="location_id" value={location_id} onChange={this.handleChange}>
            {locations.map((location) => (
              <option value={location.id} key={location.id}>{location.name}</option>
            ))}
          </select>
        </div>

        <div className="selection-block">
          <label className="column">Type:</label>
          <TypeOfPersonSelect defaultText="All" value={type_of_person} onChange={this.handleChange} options={STAFF_TYPE_OF_PEOPLE} />
        </div>

        <div className="selection-block">
          <label className="column">Roles:</label>
          <select name="role_id" value={role_id} onChange={this.handleChange}>
            <option value="">All</option>
            {roles.map((role) => (
              <option value={role.id} key={role.id}>{role.name}</option>
            ))}
          </select>
        </div>

        <div className="selection-block">
          <label className="column">Filter by Tags:</label>
          <Select name="tag_ids" onChange={this.handleMultiSelectChange} options={selectOptions} value={selectedTags} isMulti={true} unstyled={true} className="react-select" classNamePrefix="react-select" placeholder={"All"} />
        </div>
        
        <br />
        {this.renderPeople(personColours)}
      </div>
    )
  }

  render() {
    const { people, locationsLoaded, rolesLoaded, tagsLoaded, holidaysLoaded, error, unauthorized, year } = this.state;

    if (localStorage.license === "entry") {
      return <Redirect to="/upgrade" />
    }

    if (unauthorized) {
      return <Redirect to="/login"/>
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    if (locationsLoaded === false || rolesLoaded === false || tagsLoaded === false) {
      return <p>Loading ...</p>;
    }

    const colors = collectHexCodes(people.length)

    const personColours = {};

    people.forEach((person, index) => {
      personColours[person.id] = colors[index];
    });

    if (locationsLoaded && rolesLoaded && tagsLoaded) {
      return (
        <div>
          <Page title={`Staff Holidays ${year}`}>
            {this.renderFilters(personColours)}

            {people.length === 0 && (
              <p>No data found for those filters.</p>
            )}
            
            <div className={"button new-button"} onClick={this.handleNewPanel}>New Holiday</div>

            {holidaysLoaded ? (
              <div className="widgets">
                <div className="year-calendar">
                  {StaffHolidaysShow.MONTHS_IN_YEAR.map(monthIndex => this.renderMonth(monthIndex, personColours))}
                </div>

                <SlidingPane isOpen={this.state.updatePanelToggle} title="Update Holiday" width="50%"
                  onRequestClose={() => { this.closePanel() }}>
                  <HolidayForm mode="update" id={this.state.holidayId} person_id={this.state.selectedPersonId} person_name={this.state.selectedPersonName} closePanel={this.closePanel} />
                </SlidingPane>

                <SlidingPane isOpen={this.state.newPanelToggle} title="New Holiday" width="50%"
                 onRequestClose={() => { this.closePanel() }}>
                 <HolidayForm mode="create" id={this.state.holidayId} person_id={this.state.selectedPersonId} closePanel={this.closePanel} location_id={this.state.location_id} />
                </SlidingPane>
              </div>
            ) : (
              <p>Loading ...</p>
            )}
          </Page>
        </div>
      );
    }
  }

  syncParamsAndState() {
    const params = new URLSearchParams(this.props.location.search);

    const year = params.get('year') || this.state.refresh_year;
    const tag_ids = params.get('tag_ids')?.split(",").map(id => parseInt(id)) || this.state.refresh_tag_ids;
    const role_id = params.get('role_id') || this.state.refresh_role_id;
    const person_ids = params.get('person_ids')?.split(",").map(id => parseInt(id)) || this.state.refresh_person_ids;
    const type_of_person = params.get('type_of_person') || this.state.refresh_type_of_person;
    const location_id = this.props.match.params.id || this.state.location_id;

    const builtParams = buildParams(
      optionalParam("year", `${year}`),
      optionalParam("tag_ids", tag_ids),
      optionalParam("role_id", role_id),
      optionalParam("person_ids", person_ids),
      optionalParam("type_of_person", type_of_person)
    );

    const currentParams = this.props.location.search.replace("?", "");

    if (currentParams !== builtParams) {
      this.props.history.replace(`/staff-holidays/${location_id}?${builtParams}`);
      return;
    }

    this.setState({
      year: parseInt(year),
      location_id: location_id,
      person_ids: person_ids,
      tag_ids: tag_ids,
      role_id: role_id,
      type_of_person: type_of_person,
      holidaysLoaded: false
    }, () => {
      this.fetchData();
    });
  }

  componentDidMount() {
    this.syncParamsAndState();

    // Filter data

    request('GET', `/v1/a/locations`, null, () => this.setState({ unauthorized: true }))
      .then(data => {
        const filteredLocations = data.filter(location => location.staff_fulfilment)

        localStorage.setItem("staff_fulfilment_access", filteredLocations.length > 0)

        this.setState({ locations: filteredLocations, locationsLoaded: true })
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        this.setState({ error, locationsLoaded: true })
      })

    request('GET', `/v1/a/roles/names_and_ids`, null, () => this.setState({ unauthorized: true }))
      .then(data => {
        this.setState({ roles: data, rolesLoaded: true })
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        this.setState({ error, rolesLoaded: true })
      })

    request('GET', `/v1/a/tags/names_and_ids`, null, () => this.setState({ unauthorized: true }))
      .then(data => {
        this.setState({ tags: data, tagsLoaded: true })
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        this.setState({ error, tagsLoaded: true })
      })
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.search !== prevProps.location.search || this.props.match.params.id !== prevProps.match.params.id) {
      this.syncParamsAndState();
    }
  }

  fetchData() {
    const params = `date_from=${this.state.year}-01-01&date_to=${this.state.year}-12-31&location_id=${this.state.location_id}&role_id=${this.state.role_id}&type_of_person=${this.state.type_of_person}${arrayParamBuilder(null, "tag_ids", this.state.tag_ids)}`

    request('GET', `/v1/a/staff_holidays/by_person?${params}`, null, () => this.setState({ unauthorized: true }))
      .then(data => {
        this.setState({ people: data, holidaysLoaded: true })
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        this.setState({ error, holidaysLoaded: true })
      })
  }
}

export default StaffHolidaysShow;
